import React, { Component } from "react";
import PropTypes from "prop-types";
import ColoredHistogramSeries from "./ColoredHistogramSeries";
import LineSeries from "./LineSeries";

/**
 * VMACD (MACD do Volume) — painel próprio: histograma MACD (colorido por sinal)
 * + linha zero + as duas linhas DIFF e DEA. Compõe o ColoredHistogramSeries
 * genérico com dois LineSeries. yAccessor(d) retorna
 * { diff, dea, macd, direction }.
 */
class VMACDSeries extends Component {
  constructor(props) {
    super(props);
    this.histAccessor = this.histAccessor.bind(this);
    this.diffAccessor = this.diffAccessor.bind(this);
    this.deaAccessor = this.deaAccessor.bind(this);
  }
  histAccessor(d) {
    const v = this.props.yAccessor(d);
    return v ? { value: v.macd, direction: v.direction } : undefined;
  }
  diffAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.diff;
  }
  deaAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.dea;
  }
  render() {
    const {
      increasingColor,
      decreasingColor,
      strokeZeroLine,
      strokeDiff,
      strokeDea,
      className,
    } = this.props;
    return (
      <g className={className}>
        <ColoredHistogramSeries
          yAccessor={this.histAccessor}
          increasingColor={increasingColor}
          decreasingColor={decreasingColor}
          strokeZeroLine={strokeZeroLine}
        />
        <LineSeries
          yAccessor={this.diffAccessor}
          stroke={strokeDiff}
          fill="none"
        />
        <LineSeries
          yAccessor={this.deaAccessor}
          stroke={strokeDea}
          fill="none"
        />
      </g>
    );
  }
}

VMACDSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  increasingColor: PropTypes.string.isRequired,
  decreasingColor: PropTypes.string.isRequired,
  strokeZeroLine: PropTypes.object,
  strokeDiff: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeDea: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

VMACDSeries.defaultProps = {
  increasingColor: "#00DD00",
  decreasingColor: "#FF0000",
  strokeZeroLine: { color: "#666666", dash: "Solid", width: 1, opacity: 1 },
  // Paleta default do engine por ÍNDICE de série no FormulaPackage
  // [DIFF, DEA, MACD]: DIFF=Yellow(0), DEA=Red(1). O MACD é COLORSTICK e
  // renderiza verde/vermelho por sinal, ignorando a cor nominal do índice 2.
  strokeDiff: { color: "#FFFF00" },
  strokeDea: { color: "#FF0000" },
  className: "react-stockcharts-vmacd-series",
};

export default VMACDSeries;
